import React from 'react';
import hoc from './FieldHOC';

class QuantityField extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = {
      value: props.field.prop('min') || 0
    };
  }

  componentDidMount(){
    if (this.state.value > 0) {
      this.onChange({target:{value: this.state.value}});
    }
  }

  onChange(e) {
    let currencyValue = this.props.field.prop('currencyValue') * e.target.value;
    this.props.field.setSelectedValue(currencyValue);
    this.props.onChange(e.target.value);
    this.setState({
      value: e.target.value
    });
  }

  render() {
    let field = this.props.field;

    let min = this.props.field.prop('min');
    let max = this.props.field.prop('max');

    let options = [];
    for (let i = min; i <= max; i++) {
      options.push(
        <option key={`option-${i}`} value={i}>
          {i}
        </option>
      );
    }

    return (
      <div>
        <label htmlFor={this.props.name}>{this.props.title || field.get('title')}</label>
        {this.props.errorComponent}
        <select
          data-value-type="number"
          className="form-control"
          value={this.state.value}
          name={this.props.name}
          tabIndex={this.props.tabIndex}
          onChange={this.onChange.bind(this)}
        >
          {options}
        </select>
      </div>
    );
  }
}

export default hoc(QuantityField);
